import { constants } from "../../../constants";

export default class OpenPaytable {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.openPaytable();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.POKERSTARS:
                event["xc2rgShowPaytable"] = this._default;
                break;
            default:
                event["openPaytable"] = this._default
                event["paytable"] = this._default
        }

        return event;
    }
}
